__turbopack_context__.v({
  "B2BTariffOverview": "_0glG-G_B2BTariffOverview",
  "Card": "_0glG-G_Card",
  "Headline": "_0glG-G_Headline",
  "ProductCards": "_0glG-G_ProductCards",
});
